<template>
  <div class="solutions">
    <!-- 页面标题 -->
    <section class="page-title">
      <div class="container">
        <h1>解决方案</h1>
        <p>为您提供全方位的物联网解决方案</p>
      </div>
    </section>

    <!-- 解决方案列表 -->
    <section class="solutions-list">
      <div class="container">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="(solution, index) in solutions" :key="index">
            <div class="solution-card" @click="goToSolution(solution.route)">
              <div class="solution-image">
                <img :src="solution.image" :alt="solution.title">
              </div>
              <div class="solution-content">
                <h3>{{ solution.title }}</h3>
                <p>{{ solution.description }}</p>
                <ul class="features">
                  <li v-for="(feature, idx) in solution.features" :key="idx">
                    <i class="el-icon-check"></i>
                    {{ feature }}
                  </li>
                </ul>
                <!-- <el-button type="text" class="learn-more">
                  了解更多 <i class="el-icon-arrow-right"></i>
                </el-button> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="container">
        <h2>需要定制化解决方案？</h2>
        <p>我们的专业团队为您提供个性化服务</p>
        <el-button type="primary" size="large" @click="contactUs">联系我们</el-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Solutions',
  data() {
    return {
      solutions: [
        {
          title: '工业物联网',
          description: '实现工厂智能化改造，提升生产效率',
          image: require('@/assets/images/industrial.jpg'),
          route: '/solutions/industrial',
          features: [
            '设备实时监控',
            '生产数据分析',
            '智能预警系统',
            '远程运维管理'
          ]
        },
        {
          title: '智慧城市',
          description: '构建智能化城市管理系统',
          image: require('@/assets/images/smart-city.jpg'),
          route: '/solutions/smart-city',
          features: [
            '城市环境监测',
            '智能交通管理',
            '公共安全监控',
            '能源管理系统'
          ]
        },
        {
          title: '智慧农业',
          description: '打造现代化农业生产系统',
          image: require('@/assets/images/agriculture.jpg'),
          route: '/solutions/agriculture',
          features: [
            '农作物生长监测',
            '智能灌溉系统',
            '病虫害预警',
            '农产品溯源'
          ]
        }
      ]
    }
  },
  methods: {
    goToSolution(route) {
      this.$router.push(route)
    },
    contactUs() {
      this.$router.push('/contact')
    }
  }
}
</script>

<style lang="scss" scoped>
.solutions {
  .page-title {
    background: linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('~@/assets/images/solutions-bg.jpg');
    background-size: cover;
    background-position: center;
    color: #fff;
    padding: 100px 0;
    text-align: center;
    
    h1 {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    p {
      font-size: 20px;
      opacity: 0.9;
    }
  }
  
  .solutions-list {
    padding: 80px 0;
    
    .solution-card {
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      margin-bottom: 30px;
      cursor: pointer;
      transition: transform 0.3s;
      
      &:hover {
        transform: translateY(-5px);
        
        .solution-image img {
          transform: scale(1.1);
        }
        
        .learn-more i {
          transform: translateX(5px);
        }
      }
      
      .solution-image {
        height: 200px;
        overflow: hidden;
        
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s;
        }
      }
      
      .solution-content {
        padding: 20px;
        
        h3 {
          font-size: 24px;
          margin-bottom: 15px;
          color: #2c3e50;
        }
        
        p {
          color: #666;
          margin-bottom: 20px;
          line-height: 1.6;
        }
        
        .features {
          list-style: none;
          padding: 0;
          margin: 0 0 20px;
          
          li {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            color: #666;
            
            i {
              color: #409EFF;
              margin-right: 10px;
            }
          }
        }
        
        .learn-more {
          padding: 0;
          font-size: 16px;
          
          i {
            margin-left: 5px;
            transition: transform 0.3s;
          }
        }
      }
    }
  }
  
  .contact-section {
    background: #f8f9fa;
    padding: 80px 0;
    text-align: center;
    
    h2 {
      font-size: 36px;
      margin-bottom: 20px;
      color: #2c3e50;
    }
    
    p {
      font-size: 18px;
      color: #666;
      margin-bottom: 30px;
    }
  }
}

@media screen and (max-width: 768px) {
  .solutions {
    .page-title {
      padding: 60px 0;
      
      h1 {
        font-size: 32px;
      }
      
      p {
        font-size: 16px;
      }
    }
    
    .solutions-list {
      padding: 40px 0;
    }
    
    .contact-section {
      padding: 40px 0;
      
      h2 {
        font-size: 28px;
      }
      
      p {
        font-size: 16px;
      }
    }
  }
}
</style> 